import React from 'react';

import SidebarMenu, { type SidebarMenuItem } from './sidebar-menu';

const items: SidebarMenuItem[] = [
  { key: 'all', to: '/packets', label: 'All Packets' },
  { key: 'vendors', to: '/packets/vendors', label: 'Vendors' },
  { key: 'packeta', to: '/packets/vendor/packeta', label: 'Packeta Import' },
];

function SidebarPackets(): React.ReactElement {
  return <SidebarMenu items={items} />;
}

export default SidebarPackets;
